import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3093ed0e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "vertical-center" };
const _hoisted_2 = ["color"];
const _hoisted_3 = ["xlink:href"];
const _hoisted_4 = ["color"];
const _hoisted_5 = ["xlink:href"];
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    name: 'index',
    props: {
        iconClass: null,
        className: { default: "" },
        text: { default: "" },
        color: { default: "" },
        effect: { default: "light" },
        placement: { default: "bottom" }
    },
    setup(__props) {
        const props = __props;
        const iconName = computed(() => {
            return `#icon-${props.iconClass}`;
        });
        const svgClass = computed(() => {
            if (props.className) {
                return "svg-icon " + props.className;
            }
            else {
                return "svg-icon";
            }
        });
        return (_ctx, _cache) => {
            const _component_el_tooltip = _resolveComponent("el-tooltip");
            return (__props.text)
                ? (_openBlock(), _createBlock(_component_el_tooltip, _mergeProps({ key: 0 }, _ctx.$attrs, {
                    content: __props.text,
                    placement: __props.placement,
                    effect: __props.effect
                }), {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            (_openBlock(), _createElementBlock("svg", {
                                class: _normalizeClass(_unref(svgClass)),
                                color: __props.color,
                                "aria-hidden": "true"
                            }, [
                                _createElementVNode("use", { "xlink:href": _unref(iconName) }, null, 8, _hoisted_3)
                            ], 10, _hoisted_2))
                        ])
                    ]),
                    _: 1
                }, 16, ["content", "placement", "effect"]))
                : (_openBlock(), _createElementBlock("svg", {
                    key: 1,
                    class: _normalizeClass(_unref(svgClass)),
                    color: __props.color,
                    "aria-hidden": "true"
                }, [
                    _createElementVNode("use", { "xlink:href": _unref(iconName) }, null, 8, _hoisted_5)
                ], 10, _hoisted_4));
        };
    }
});
